import { Link } from "react-router-dom";
import { operatorPlanContent as op } from "../content/operator-plan.js";

export default function OperatorPlanPage() {
  return (
    <article className="site-page site-page--operator">
      <div className="site-page__inner site-page__inner--wide">
        <aside className="disclaimer-banner operator-banner" role="note">
          <strong>Operator-only.</strong> {op.warning}
        </aside>

        <p className="site-page__eyebrow">Internal</p>
        <h1 className="site-page__title">Operator planning scratchpad</h1>
        <p className="site-page__note">{op.secrecy}</p>

        <section className="site-section">
          <h2>{op.revenueScenarios.headline}</h2>
          {op.revenueScenarios.projects.map((p) => (
            <article key={p.label} className="operator-card">
              <h3>{p.label}</h3>
              {p.projectsPerMo ? <p>{p.projectsPerMo}</p> : null}
              {p.averageTicket ? <p>{p.averageTicket}</p> : null}
              {p.description ? <p>{p.description}</p> : null}
              <p className="operator-card__stat">
                <strong>Monthly (illustrative):</strong> {p.monthlyImplied}
              </p>
              <p className="operator-card__stat">
                <strong>Annual band (illustrative):</strong> {p.yearlyImplied}
              </p>
            </article>
          ))}
        </section>

        <section className="site-section">
          <h2>Illustrative operating expense placeholders</h2>
          <table className="pricing-table">
            <thead>
              <tr>
                <th>Category</th>
                <th>Planning placeholder</th>
              </tr>
            </thead>
            <tbody>
              {op.expenses.map((row) => (
                <tr key={row.category}>
                  <td>{row.category}</td>
                  <td>{row.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="site-page__lead">{op.marginNote}</p>
        </section>

        <section className="site-section">
          <h2>Launch checklist buckets</h2>
          <div className="operator-checklist-grid">
            {op.launchChecklist.map((grp) => (
              <article key={grp.title} className="operator-checklist-card">
                <h3>{grp.title}</h3>
                <ul className="site-page__list">
                  {grp.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </section>

        <p className="site-page__muted">
          <Link to="/">← Home</Link>
        </p>
      </div>
    </article>
  );
}
